(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-dots"] && !Shopify.designMode) return;
  try {
    (() => {
    function itemsOf(scroller) {
      return Array.prototype.slice.call(scroller.children);
    }

    /* The item whose left edge sits closest to where the scroller has been
       scrolled to. The last item rarely reaches that position — the strip runs
       out of scroll before it gets there — so the end of the track counts as
       the last item. */
    function activeIndex(scroller) {
      const items = itemsOf(scroller);
      if (items.length === 0) return 0;

      const max = scroller.scrollWidth - scroller.clientWidth;
      if (scroller.scrollLeft >= max - 2) return items.length - 1;

      const base = items[0].offsetLeft;
      let closest = Infinity;
      let index = 0;

      items.forEach((item, i) => {
        const distance = Math.abs(item.offsetLeft - base - scroller.scrollLeft);
        if (distance < closest) {
          closest = distance;
          index = i;
        }
      });

      return index;
    }

    function connect(dots) {
      if (dots.dataset.scrollDotsReady) return;

      const scroller = document.querySelector(`[data-snap-scroller="${dots.dataset.scrollDots}"]`);
      if (!scroller) return;

      dots.dataset.scrollDotsReady = 'true';

      const buttons = Array.prototype.slice.call(dots.querySelectorAll('[data-scroll-dot]'));

      function sync() {
        dots.hidden = scroller.scrollWidth <= scroller.clientWidth + 4;

        const index = activeIndex(scroller);
        buttons.forEach((button, i) => {
          button.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      scroller.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(scroller);

      dots.addEventListener('click', (event) => {
        const button = event.target.closest('[data-scroll-dot]');
        if (!button) return;

        const items = itemsOf(scroller);
        const item = items[Number(button.dataset.scrollDot)];
        if (!item) return;

        scroller.scrollTo({
          left: item.offsetLeft - items[0].offsetLeft,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });

      sync();
    }

    function init(root) {
      (root || document).querySelectorAll('[data-scroll-dots]').forEach(connect);
    }

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-behaviour"] && !Shopify.designMode) return;
  try {
    (() => {
    const configEl = document.getElementById('elmewind-config');
    const config = configEl ? JSON.parse(configEl.textContent) : {};
    const strings = config.strings || {};

    /* ----------------------------------------------------------------
       Toast
       ---------------------------------------------------------------- */

    let toastTimer;

    function toast(message) {
      const el = document.querySelector('[data-toast]');
      if (!el) return;
      el.textContent = message;
      el.setAttribute('data-visible', 'true');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => el.removeAttribute('data-visible'), 1700);
    }

    /* ----------------------------------------------------------------
       Cart
       ---------------------------------------------------------------- */

    const SECTION_ID = 'cart-drawer';

    function drawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function openDrawer() {
      const el = drawer();
      if (!el) return;
      if (typeof el.showModal === 'function' && !el.open) el.showModal();
    }

    function closeDrawer() {
      const el = drawer();
      if (el && el.open) el.close();
    }

    function applySections(sections) {
      if (!sections) return;
      const html = sections[SECTION_ID];
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector('[data-cart-drawer-content]');
      const current = document.querySelector('[data-cart-drawer-content]');
      if (next && current) current.innerHTML = next.innerHTML;
    }

    function applyCount(count) {
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.toggleAttribute('data-empty', count === 0);
      });
    }

    async function post(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(
          Object.assign({ sections: SECTION_ID, sections_url: window.location.pathname }, body)
        ),
      });

      const data = await response.json().catch(() => null);

      if (!response.ok) {
        const message = (data && (data.description || data.message)) || strings.error;
        throw new Error(message);
      }

      return data;
    }

    async function addToCart(items) {
      const data = await post(config.cartAddUrl, { items });
      applySections(data.sections);
      const count = await refreshCount();
      openDrawer();
      toast(strings.added);
      return count;
    }

    async function changeLine(line, quantity) {
      const data = await post(config.cartChangeUrl, { line: Number(line), quantity: Number(quantity) });
      applySections(data.sections);
      applyCount(data.item_count);
      return data;
    }

    async function refreshCount() {
      try {
        const response = await fetch(`${config.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const cart = await response.json();
        applyCount(cart.item_count);
        return cart.item_count;
      } catch (error) {
        return null;
      }
    }

    function setBusy(el, busy) {
      if (!el) return;
      if (busy) {
        el.setAttribute('aria-disabled', 'true');
        el.dataset.busy = 'true';
      } else {
        el.removeAttribute('aria-disabled');
        delete el.dataset.busy;
      }
    }

    function showFormError(form, message) {
      if (!form) return;
      let box = form.querySelector('[data-form-error]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'form-errors';
        box.setAttribute('data-form-error', '');
        form.prepend(box);
      }
      box.textContent = message;
    }

    window.ElmeWind = {
      addToCart,
      changeLine,
      refreshCount,
      openDrawer,
      closeDrawer,
      toast,
    };

    /* ----------------------------------------------------------------
       Delegated events
       ---------------------------------------------------------------- */

    document.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[data-cart-open]');
      if (openBtn && drawer()) {
        event.preventDefault();
        openDrawer();
        return;
      }

      const closeBtn = event.target.closest('[data-cart-close]');
      if (closeBtn) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const quickAdd = event.target.closest('[data-quick-add]');
      if (quickAdd) {
        event.preventDefault();
        if (quickAdd.dataset.busy) return;
        setBusy(quickAdd, true);
        addToCart([{ id: Number(quickAdd.dataset.quickAdd), quantity: 1 }])
          .catch((error) => toast(error.message || strings.error))
          .finally(() => setBusy(quickAdd, false));
        return;
      }

      const lineBtn = event.target.closest('[data-line-change]');
      if (lineBtn) {
        event.preventDefault();
        if (lineBtn.dataset.busy) return;
        setBusy(lineBtn, true);
        changeLine(lineBtn.dataset.line, lineBtn.dataset.lineChange)
          .catch((error) => toast(error.message || strings.error))
          .finally(() => setBusy(lineBtn, false));
        return;
      }

      const step = event.target.closest('[data-qty-step]');
      if (step) {
        event.preventDefault();
        const wrapper = step.closest('[data-qty]');
        const input = wrapper && wrapper.querySelector('[data-qty-input]');
        if (!input) return;
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        const next = Number(input.value || min) + Number(step.dataset.qtyStep);
        input.value = Math.min(max, Math.max(min, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[data-cart-add]');
      if (!form) return;

      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button && button.dataset.busy) return;
      setBusy(button, true);

      const data = new FormData(form);
      const id = data.get('id');
      const quantity = Number(data.get('quantity') || 1);
      if (!id) {
        setBusy(button, false);
        return;
      }

      const item = { id: Number(id), quantity };
      const properties = {};
      data.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (!match) return;
        const clean = typeof value === 'string' ? value.trim() : value;
        if (clean) properties[match[1]] = clean;
      });
      if (Object.keys(properties).length) item.properties = properties;

      const existing = form.querySelector('[data-form-error]');
      if (existing) existing.remove();

      addToCart([item])
        .catch((error) => {
          const message = error.message || strings.error;
          showFormError(form, message);
          toast(message);
        })
        .finally(() => setBusy(button, false));
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-line-qty]');
      if (!input) return;
      changeLine(input.dataset.line, input.value).catch((error) =>
        toast(error.message || strings.error)
      );
    });

    document.addEventListener('click', (event) => {
      const el = drawer();
      if (!el || !el.open) return;
      const rect = el.getBoundingClientRect();
      const outside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;
      if (outside && event.target === el) el.close();
    });

    /* ----------------------------------------------------------------
       Header: scroll state + measured height
       ---------------------------------------------------------------- */

    const root = document.documentElement;
    const threshold = config.scrollThreshold || 120;
    let scrolled = null;
    let pinned = null;
    let pinPoint = threshold;
    let frame = null;

    function onScroll() {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        const y = window.scrollY;

        const past = y > threshold;
        if (past !== scrolled) {
          scrolled = past;
          root.toggleAttribute('data-scrolled', past);
        }

        /*
          The condensed header takes over the moment the expanded one leaves
          the viewport, so the two are never on screen at the same time.
        */
        const over = y > pinPoint;
        if (over !== pinned) {
          pinned = over;
          root.toggleAttribute('data-header-pinned', over);
        }
      });
    }

    /*
      `--header-height` is what other sections keep clear of, so it measures the
      condensed bar: that is the only part of the header that ever covers the
      top of the viewport.
    */
    function measureHeader() {
      const compact = document.querySelector('[data-header-compact]');
      if (compact) {
        const height = Math.round(compact.getBoundingClientRect().height);
        if (height) root.style.setProperty('--header-height', `${height}px`);
      }

      const full = document.querySelector('[data-header-full]');
      if (full) {
        pinPoint = Math.round(full.getBoundingClientRect().bottom + window.scrollY);
      }
    }

    /* Re-measure and re-evaluate together: a resize moves the point where the
       condensed header takes over, so the state has to follow immediately
       rather than waiting for the next scroll. */
    function refresh() {
      measureHeader();
      onScroll();
    }

    function watchHeader() {
      refresh();

      if (!('ResizeObserver' in window)) return;

      const observer = new ResizeObserver(refresh);
      document.querySelectorAll('[data-header-full], [data-header-compact]').forEach((el) => {
        observer.observe(el);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchHeader);
    } else {
      watchHeader();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
